import React from "react";
import { Button, CircularProgress, Dialog } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "localization/translation";

const ConfirmActionModal = ({
  open,
  onClose,
  onConfirm,
  title,
  text,
  confirmLabel,
  danger = false,
  loading = false,
}) => {
  const translation = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      classes={{ paper: "shadow-lg rounded" }}
    >
      <div className="text-center p-5">
        <div className="avatar-icon-wrapper rounded-circle m-0">
          <div
            className={`d-inline-flex justify-content-center p-0 rounded-circle btn-icon avatar-icon-wrapper m-0 d-130 ${
              danger
                ? "text-danger bg-neutral-danger"
                : "text-success bg-neutral-success"
            }`}
          >
            <FontAwesomeIcon
              icon={["fas", danger ? "times" : "check"]}
              className="d-flex align-self-center display-3"
            />
          </div>
        </div>
        <h4 className="font-weight-bold mt-4">{title}</h4>
        {text ? <p className="mb-0 font-size-lg text-muted">{text}</p> : null}
        <div className="pt-4">
          <Button
            onClick={onClose}
            disabled={loading}
            className="btn-neutral-secondary btn-pill mx-1"
          >
            <span className="btn-wrapper--label">{translation.cancel}</span>
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            className={`${danger ? "btn-danger" : "btn-success"} btn-pill mx-1`}
          >
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <span className="btn-wrapper--label btn-action">
                {confirmLabel}
              </span>
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmActionModal;
